import FullWidthImageSlider from "../../../../src/components/FullWidthImageSlider";
import Slide from "../../../../src/components/FullWidthImageSlider/Slide";
import OutboundLink from "../../../../src/components/OutboundLink";
import SnappySlider from "../../../../src/components/SnappySlider";
import SnappySlide from "../../../../src/components/SnappySlider/SnappySlide";
import * as React from 'react';
export default {
  FullWidthImageSlider,
  Slide,
  OutboundLink,
  SnappySlider,
  SnappySlide,
  React
};